import * as types from "./types";

const initialState = {
  loading: false,
};

const userTags = (state = initialState, action) => {
  switch (action.type) {
    case types.ASSIGN_USER_TAG_REQUEST:
    case types.REMOVE_USER_TAG_REQUEST:
      return { ...state, loading: true };
    case types.USER_TAG_RESPONSE:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default userTags;
